exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-avatar_container[data-v-4684a4f4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 0 8px 0 5px;\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #eee;\n  vertical-align: middle;\n  overflow: hidden;\n}\n.user-avatar_container > img[data-v-4684a4f4] {\n    width: 30px;\n    height: 30px;\n}\n", ""]);

// exports
